module.exports = __webpack_public_path__ + "i18n/uk.ed65fdf5626a5f5a1f21e25fcb3fc157.json";